import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, IonSlides } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-product-slides',
  templateUrl: './product-slides.page.html',
  styleUrls: ['./product-slides.page.scss'],
})
export class ProductSlidesPage implements OnInit {
  @Input() productImages;
  @Input() activeImage;
  sliderOptions:any;
  @ViewChild('sliderProduct', { static: false }) sliderProduct: IonSlides;

  constructor(public modalController: ModalController, private analyticsService: AnalyticsService) {
    this.analyticsService.AnalyticsServiceModalView('product-slides');
  } 

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.sliderOptions = {
      slidesPerView: 1,
      initialSlide: this.activeImage.index
    }
  }
  
  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }

  //Functions to change slides
  swipeNext(){
    console.log('not working')
    this.sliderProduct.slideNext();
  }
  swipePrev(){
    this.sliderProduct.slidePrev();
  }
}
